import PropTypes from "prop-types";
import React from "react";

import Icon from "../interface/Icon";
import { withOptionalTooltip } from "../interface/Tooltip";

const renderButton = props => (
  <div
    id={props.id ? props.id : null}
    className={`sideBarItem ${props.active ? "active" : ""} ${props.color}`}
    onClick={props.onClick ? () => props.onClick(props.clickContext) : null}
  >
    <Icon icon={props.icon} color={props.color} pulse={props.pulse} />
    {props.badge ? <span className={`badge ${props.badgeColor}`}>{props.badge}</span> : null}
  </div>
);

const SidebarButton = props => {
  return withOptionalTooltip(renderButton(props), props.tooltip, { placement: "right" });
};

SidebarButton.propTypes = {
  onClick: PropTypes.func,
  icon: PropTypes.string.isRequired,
  color: PropTypes.string,
  active: PropTypes.bool.isRequired,
  pulse: PropTypes.bool,
  clickContext: PropTypes.string,
  id: PropTypes.string,
  badge: PropTypes.number,
  badgeColor: PropTypes.string,
  tooltip: PropTypes.string
};

renderButton.propTypes = SidebarButton.propTypes;

export default SidebarButton;
